import { useState, useCallback } from 'react';

const STORAGE_KEY = 'sidebar-collapsed';

export function useSidebarCollapsed(): [boolean, (value: boolean) => void] {
    const [collapsed, setCollapsedState] = useState<boolean>(() => {
        try {
            return localStorage.getItem(STORAGE_KEY) === 'true';
        } catch {
            return false;
        }
    });

    const setCollapsed = useCallback((value: boolean) => {
        setCollapsedState(value);
        try {
            localStorage.setItem(STORAGE_KEY, String(value));
        } catch {
            // localStorage unavailable
        }
    }, []);

    return [collapsed, setCollapsed];
}
